import { render, staticRenderFns } from "./LightStatistics.vue?vue&type=template&id=8986f5fe&scoped=true"
import script from "./LightStatistics.vue?vue&type=script&lang=js"
export * from "./LightStatistics.vue?vue&type=script&lang=js"
import style0 from "./LightStatistics.vue?vue&type=style&index=0&id=8986f5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8986f5fe",
  null
  
)

export default component.exports